import { Injectable, Injector, inject } from '@angular/core';
import { PkceCode } from '../../../models';
import { SwapAccessTokenService } from '../../swap-access-token-service/swap-access-token-service';
import { LoginPostWithContinueService } from '../login-remember-me-adapter-service/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithCredService } from '../login-remember-me-adapter-service/login-post-with-cred/login-post-with-cred-service';
import { LoginPostWithRememberUserService } from '../login-remember-me-adapter-service/login-post-with-remember-user/login-post-with-remember-user-service';
import { LoginRememberMeErrorUtilService } from '../login-remember-me-utils-service/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../login-remember-me-utils-service/login-remember-me-utils.service';
@Injectable({
  providedIn: 'root'
})
export class PostWithCredentialsFacadeHelperService {
  loginPostWithCred = inject(LoginPostWithCredService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  LoginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);
  injector = inject(Injector);

  flowId = '';
  encyToken = '';
  uid = '';
  pkceCode = {} as PkceCode;
}
